import { Pencil } from 'assets/icons';
import Button from 'components/button';
import useText from 'hooks/useText';

// « C’est vendredi : 2 minutes pour faire le bilan de votre semaine. »
const ReviewReminder = ({ day, onOpen }) => {
  const { text } = useText('stats');
  return (
    <section className="flex items-center gap-3 rounded-[14px] bg-gray-100 py-3 pl-5 pr-3">
      <span className="flex shrink-0 text-gray-900">
        <Pencil wh={18} color="currentColor" />
      </span>
      <p className="flex-1 text-sm font-medium leading-5 text-gray-900">
        {text('reminder', { day })}
      </p>
      <Button color="PRIMARY" size="SM" onClick={onOpen}>
        {text('reminderCta')}
      </Button>
    </section>
  );
};

export default ReviewReminder;
